import {useQuery} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import { Permission } from './auth.datatypes';

interface PermissionsData {
    permissions: Permission[],
}

export const GET_PERMISSIONS_QUERY = gql`
    query getPermissions{
      permissions {
        id
        name
        ident
        description
      }
    }
`;

export const getPermissions = () => useQuery<PermissionsData>(
    GET_PERMISSIONS_QUERY,
    {
        variables: {
        }
    }
);

export default getPermissions;